import { db } from '../config/fbConfig'
import { doc, getDoc } from 'firebase/firestore'


const getProject = async (projectId) => {
  const docRef = doc(db, "projects", projectId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return 'error'
  }
}

export { getProject };
